import Moment from "moment";

export function formatDate(
  date,
  fromFormat = "YYYY-MM-DD",
  toFormat = "M j, Y"
) {
  if (
    date === "0000-00-00" ||
    date === "0000-00-00 00:00:00" ||
    date === "" ||
    date == null
  )
    return "";
  else {
    if (toFormat === "M j, Y" || toFormat === "M j, Y g:iA")
      return Moment(date, fromFormat).format("MMM D, Y");
    else if (toFormat === "n/j/Y" || toFormat === "n/j/Y g:iA")
      return Moment(date, fromFormat).format("MM/D/Y");
    else if (toFormat === "Y/n/j" || toFormat === "Y/n/j g:iA")
      return Moment(date, fromFormat).format("Y/MM/D");
    else if (toFormat === "D, M j" || toFormat === "D, M j g:iA")
      return Moment(date, fromFormat).format("ddd, MMM D");
    else return "Invalid date";
  }
}

export function getFormat(fromFormat = "M j, Y", time = false) {
  if (fromFormat === "M j, Y" || fromFormat === "M j, Y g:iA")
    return "MMM DD, YYYY" + (time ? " hh:mm a" : "");
  else if (fromFormat === "n/j/Y" || fromFormat === "n/j/Y g:iA")
    return "MM/DD/YYYY" + (time ? " hh:mm a" : "");
  else if (fromFormat === "Y/n/j" || fromFormat === "Y/n/j g:iA")
    return "YYYY/MM/DD" + (time ? " hh:mm a" : "");
  else if (fromFormat === "D, M j" || fromFormat === "D, M j g:iA")
    return "ddd, MMM DD" + (time ? " hh:mm a" : "");
  else return "MMM DD, YYYY" + (time ? " hh:mm a" : "");
}

export function formatTime(value, columnTypeId) {
  if (
    value &&
    value !== "" &&
    columnTypeId != "4" &&
    Moment(value, "YYYY-MM-DD HH:mm:ss").isValid()
  ) {
    return Moment(value, "YYYY-MM-DD HH:mm:ss").format("hh:mm a");
  }
  return "";
}

export function getDateFormat(groupOption) {
  switch (groupOption) {
    case "y":
      return "YYYY";
    case "m":
      return "MMM";
    case "my":
      return "MMM YYYY";
    case "d":
      return "MMMM DD, YYYY";
    default:
      return "YYYY";
  }
}
